import React from 'react'
import { Badge, Button } from 'reactstrap'
import { Table, Empty, Divider, message, Popconfirm } from 'antd'
import moment from 'moment'

import { deleteWarehouseDock, updateWarehouseDock } from '../services'
import { handleError } from '../../../helpers'

export default function WarehouseDocksTable({ warehouseDocks, reload }) {

    const columns = [
        {
            title: 'ID CENF',
            dataIndex: 'id'
        },
        {
            title: 'Nombre del Muelle',
            dataIndex: 'name'
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            render: t => <Badge color={t.color}>{t.label}</Badge>
        },   
        {
            title: 'Acciones',
            render: (t, r) => (
                <React.Fragment>
                    <Button color='primary' outline onClick={() => handleToggle(r)}>
                        { t.disabled_at ? 'Activar' : 'Desactivar' }
                    </Button>
                    <Divider type='vertical' />
                    { r.appointments_count === 0 && (
                        <Popconfirm
                            title='¿Estás seguro de querer eliminar este muelle?'
                            onConfirm={() => handleDelete(r.id)}
                            okText='Eliminar'
                            cancelText='Cancelar'
                            okButtonProps={{ danger: true }}
                        >
                            <Button color='danger' outline>
                                Eliminar
                            </Button>
                        </Popconfirm>
                    )}
                </React.Fragment>
            )
        }
    ]

    const handleDelete = id => {
        deleteWarehouseDock(id)
            .then(res => {
                message.success(res.data.message)
                reload()
            })
    }

    const handleToggle = r => {
        updateWarehouseDock(r.id, {
            disabled_at: r.disabled_at ? null : moment().format('YYYY-MM-DD HH:mm:ss') 
        })
            .then(res => {
                message.success(res.data.message)
                reload()
            })
            .catch(error => handleError(error))
    }

	return (
		<React.Fragment>
			<Table 
                rowKey={r => r.id}
                dataSource={warehouseDocks} 
                columns={columns} 
                size='small'
                locale={{ 
                    emptyText: (
                        <Empty 
                            description="No se encontraron registros" 
                            imageStyle={{ height:'80px' }}
                        />
                    ) 
                }}
            />
		</React.Fragment>
	)
}